import script from "./ObjectAssetBrowser.vue?vue&type=script&setup=true&lang=js"
export * from "./ObjectAssetBrowser.vue?vue&type=script&setup=true&lang=js"

import "./ObjectAssetBrowser.vue?vue&type=style&index=0&id=351bbc40&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-351bbc40"]])

export default __exports__